import { render, staticRenderFns } from "./ClockIcon.vue?vue&type=template&id=afc1e08c&"
import script from "./ClockIcon.vue?vue&type=script&lang=js&"
export * from "./ClockIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports